import { axiosIntance } from "./config"

export const getAllConfig = async()=>{
    const response = await axiosIntance.get('/events')
    return response.data
}


export const updateConfig = async (id,data) => {
  const response = await axiosIntance.put(`/events/${id}`,data); 
  return response.data;
};

export const createConfig = async (data) => {
  const response = await axiosIntance.post(`/events`, data); 
  return response.data;
};

export const getConfig = async(id)=>{
    const response = await axiosIntance.get(`/events/${id}`)
    return response.data
}

export const deleteConfig = async(id)=>{
    const response = await axiosIntance.delete(`/events/${id}`)
    return response.data
}